// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_page__zqtmE {
    /*width: var(--container-width);*/
    /*padding: 0 var(--container-padding);*/
    /*max-width: 100%;*/
    /*margin: 0 auto;*/
}

.styles_header__W1P6A {
    /*font-family: var(--font-secondary);*/
    color: var(--primary-color-active);
    /*margin: var(--container-margin) 0;*/
    /*font-size: 35px;*/
    font-weight: 700;
}

/*.item {*/
/*    width: 140px;*/
/*}*/
`, "",{"version":3,"sources":["webpack://./src/pages/Compliance/styles.module.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,kCAAkC;IAClC,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,UAAU;AACV,oBAAoB;AACpB,IAAI","sourcesContent":[".page {\n    /*width: var(--container-width);*/\n    /*padding: 0 var(--container-padding);*/\n    /*max-width: 100%;*/\n    /*margin: 0 auto;*/\n}\n\n.header {\n    /*font-family: var(--font-secondary);*/\n    color: var(--primary-color-active);\n    /*margin: var(--container-margin) 0;*/\n    /*font-size: 35px;*/\n    font-weight: 700;\n}\n\n/*.item {*/\n/*    width: 140px;*/\n/*}*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `styles_page__zqtmE`,
	"header": `styles_header__W1P6A`
};
export default ___CSS_LOADER_EXPORT___;
